export const INTERVAL_UNITS = [
  { value: 'minutes', label: 'Minutes' },
  { value: 'hours', label: 'Hours' },
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years' },
];

export function capitalizeUnit(unit, value) {
  const raw = String(unit || '')
    .toLowerCase()
    .replace(/s$/, '');
  if (!raw) return '';
  const base = raw.charAt(0).toUpperCase() + raw.slice(1);
  return Number(value) === 1 ? base : `${base}s`;
}

export function formatInterval(value, unit) {
  if (value == null || value === '' || !unit) return '-';
  const unitLabel = capitalizeUnit(unit, value);
  if (!unitLabel) return '-';
  return `Every ${value} ${unitLabel}`;
}
